import EditClientAllocation from './EditCrisisAllocation';

export default EditClientAllocation;
